import { useQueryClient } from "@tanstack/react-query";
import { useToastMessagesStore } from "@/Stores/ToastMessagesStore";
import { useParams } from "react-router-dom";
import { QueryKeys } from "@/Service/Api/V1/QueryKeys/QueryKeys";
import PageLayout from "@/Themes/Default/Layouts/PageLayout";
import { can } from "@/Util/permissionChecks";
import TeamForm, { TeamFormData } from "@/Components/Forms/TeamForm";
import { useGetTeam } from "@/Service/Api/V1/ApiHooks/Teams/useGetTeam";
import { useUpdateTeam } from "@/Service/Api/V1/ApiHooks/Teams/useUpdateTeam";

const TeamPage = () => {
    const queryClient = useQueryClient();
    const addToastMessage = useToastMessagesStore((state) => state.addToastMessage);

    const { teamId } = useParams();
    const { data: team } = useGetTeam({
        requestParams: {
            team_id: Number(teamId)
        },
        enabled: !!teamId
    });
    const { mutateAsync: updateTeam, isPending } = useUpdateTeam();

    const handleUpdateTeam = async (data: TeamFormData) => {
        if(!team) return;
        await updateTeam({
            team_id: team.id.toString(),
            UpdateTeamRequest: {
                ...data,
            }
        }, {
            onSuccess: async () => {
                await queryClient.invalidateQueries({
                    queryKey: QueryKeys.teams._def
                });
                addToastMessage({
                    severity: 'success',
                    summary: 'Team updated',
                    detail: 'Team has been updated successfully',
                });
            },
            onError: (error) => {
                addToastMessage({
                    severity: 'error',
                    summary: 'Failed to update team',
                    detail: error.message,
                });
            }
        });
    };

    return (
        <PageLayout>
            <TeamForm
                initFormData={team}
                onSubmit={handleUpdateTeam}
                isProcessing={isPending}
                onSubmitButtonLabel='Update team'
                onSubmitButtonDisabled={!can('edit:team')}
            />
        </PageLayout>
    );
};

export default TeamPage;